import { Sprout, Clock, Hand, Package } from "lucide-react";

const items = [
  { icon: Sprout, title: "Natural Soy Wax", desc: "100% plant-based, clean burning wax free from paraffin and toxins." },
  { icon: Clock, title: "Long Lasting", desc: "Up to 60 hours of even, steady burn across every fragrance." },
  { icon: Hand, title: "Handmade", desc: "Poured, cured and finished by hand in small batches." },
  { icon: Package, title: "Luxury Packaging", desc: "Signature keepsake boxes made for gifting from the moment they arrive." },
];

export function WhyChoose() {
  return (
    <section className="py-14 lg:py-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="eyebrow">The Royal Lumina Promise</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl">
            Why <span className="italic text-gold">Choose Us</span>
          </h2>
          <div className="mx-auto mt-5 h-px w-20 bg-gold" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {items.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="group relative bg-card rounded-[20px] p-8 shadow-luxe hover:shadow-luxe-hover transition-all duration-500 hover:-translate-y-1">
              <div className="h-14 w-14 rounded-full bg-gold/10 grid place-items-center group-hover:bg-gold transition-colors duration-500">
                <Icon className="h-6 w-6 text-gold group-hover:text-primary transition-colors" strokeWidth={1.4} />
              </div>
              <h3 className="font-display text-2xl mt-6">{title}</h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
